import { render, staticRenderFns } from "./ProjectUploadAdmin.vue?vue&type=template&id=5128d92c&scoped=true"
import script from "./ProjectUploadAdmin.vue?vue&type=script&lang=js"
export * from "./ProjectUploadAdmin.vue?vue&type=script&lang=js"
import style0 from "./ProjectUploadAdmin.vue?vue&type=style&index=0&id=5128d92c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5128d92c",
  null
  
)

export default component.exports